import Component from './analytics_chart_vertical.vue'
export default Component
